<template>
  <div class="reg-progress-container">
    <div class="reg-progress-bar">
      <!-- 步驟 1: 帳號設定 -->
      <div
        class="progress-step"
        :class="{
          completed: currentStepIndex > 0,
          active: currentStepIndex === 0,
          pending: currentStepIndex < 0,
        }"
      >
        <div class="progress-bar"></div>
        <div class="step-label">{{ $t("register.stepEmail") }}</div>
      </div>

      <!-- 步驟 2: 個人資料 -->
      <div
        class="progress-step"
        :class="{
          completed: currentStepIndex > 1,
          active: currentStepIndex === 1,
          pending: currentStepIndex < 1,
        }"
      >
        <div class="progress-bar"></div>
        <div class="step-label">{{ $t("register.stepProfile") }}</div>
      </div>

      <!-- 步驟 3: 完成註冊 -->
      <div
        class="progress-step"
        :class="{
          completed: currentStepIndex > 2,
          active: currentStepIndex === 2,
          pending: currentStepIndex < 2,
        }"
      >
        <div class="progress-bar"></div>
        <div class="step-label">{{ $t("register.stepDone") }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  currentStep: {
    type: Number,
    required: true,
    validator: (value) => value >= 1 && value <= 3,
  },
});

const currentStepIndex = computed(() => props.currentStep - 1);
</script>

<style scoped>
.reg-progress-container {
  width: 100%;
  display: flex;
  justify-content: center;
  margin: 30px auto;
}

.reg-progress-bar {
  width: min(520px, 100%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
}

.progress-step {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.progress-bar {
  width: 100%;
  height: 10px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

/* 已完成步驟 */
.progress-step.completed {
  opacity: 0.8;
}
.progress-step.completed .progress-bar {
  background-color: #cccfff;
}

.progress-step.completed .step-label {
  color: #cccfff;
  font-weight: 400;
}

/* 當前步驟 */
.progress-step.active .progress-bar {
  background-color: var(--color-primary);
}

.progress-step.active .step-label {
  color: var(--color-primary);
  font-weight: 500;
}

/* 未到步驟 */
.progress-step.pending .progress-bar {
  background-color: #e0e0e0;
}

.progress-step.pending .step-label {
  color: rgba(0, 0, 0, 0.4);
  font-weight: 400;
}

.step-label {
  font-size: 14px;
  text-align: center;
  transition: all 0.3s ease;
}

@media (max-width: 1024px) {
  .reg-progress-container {
    margin: 18px auto;
    padding: 0 16px;
  }

  .step-label {
    font-size: 12px;
  }

  .progress-step {
    gap: 8px;
  }

  .progress-bar {
    height: 8px;
  }
}
</style>
